export default __webpack_public_path__ + "0c7724984d814511f6b489a038c65a6e.png";